import React, { useState } from "react";
import "../App.css";

function Register() {
  const [currentStep, setCurrentStep] = useState(1);
  const [selectedLink, setSelectedLink] = useState("");

  const goToNextStep = () => {
    setCurrentStep(currentStep + 1);
  };

  const handleLinkSelection = (link) => {
    setSelectedLink(link);
    goToNextStep();
  };

  return (
    <div className="Register">
      <h2>Multi-Step Form</h2>
      <div className="steps">
        <div className={currentStep === 1 ? "active-step" : ""}>Details</div>
        <div className={currentStep === 2 ? "active-step" : ""}>
          Preferences
        </div>
        <div className={currentStep === 3 ? "active-step" : ""}>Complete</div>
      </div>
      {currentStep === 1 && (
        <div className="step-content">
          <p>Who is this form for?</p>
          <button onClick={() => handleLinkSelection("Me")}>Me</button>
          <button
            onClick={() => handleLinkSelection("Friend or family member")}
          >
            Friend or family member
          </button>
          <button onClick={() => handleLinkSelection("My client")}>
            My client
          </button>
        </div>
      )}
      {currentStep === 2 && (
        <div className="step-content">
          <p>Preferences for {selectedLink}</p>
          <button onClick={goToNextStep}>Next</button>
        </div>
      )}
      {currentStep === 3 && (
        <div className="step-content">
          <p>Completion step</p>
        </div>
      )}
    </div>
  );
}

export default Register;
